<template>
    <container>
        <row>
            <column :md="contentMdCol" :lg="contentLgCol" class="py-5">
                <h3>We couldn't find an properties based on your search request. Try to change your search parameters or contact us a personalized approach</h3>
            </column>
            <column :md="cardMdCol" :lg="cardLgCol" class="pb-4">
                <personal-approach-card :checkIn="checkIn" :checkOut="checkOut" :adults="adults" :children="children" :inquireType="inquireType" class="h-100"/>
            </column>
        </row>
    </container>
</template>

<script type="text/javascript">
    import PersonalApproachCard from '@/components/Content/Public/Properties/Cards/PersonalApproach.vue';
    import CommonComponents from '@/components/Common.vue';

    import DateObject from '@/classes/DateObject.js';

    export default {
        components: {
            PersonalApproachCard,
            ...CommonComponents,
        },

        props: {
            checkIn: {
                type: DateObject,
            },

            checkOut: {
                type: DateObject,
            },

            adults: {
                type: Number,
            },

            children: {
                type: Number,
            },

            stacked: {
                type: Boolean,
                default: false,
            },

            inquireType: {
                type: String,
            },
        },

        computed: {
            contentMdCol() {
                if (this.stacked) {
                    return 24;
                }
                return 12;
            },

            cardMdCol() {
                if (this.stacked) {
                    return 24;
                }
                return 12;
            },

            contentLgCol() {
                if (this.stacked) {
                    return 24;
                }
                return 16;
            },

            cardLgCol() {
                if (this.stacked) {
                    return 24;
                }
                return 8;
            },
        },

    };

</script>
